import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Panel from 'components/Panel';
import FormErrorsBox from 'components/FormErrorsBox';
import FeedRationForm from './components/FeedRationForm';
// endpoints
import { createFeedRation } from 'endpoints/admin/feedRations';
// constants
import { feedRationFormName, feedRationsPath, medicationErrorKeys, rawMedicationErrorKeys } from './constants';
// utils
import handleFormErrors from 'utils/handleFormErrors';
import { showToastrMessage } from 'utils';
import { serializeFeedRation } from './helper';

const initialValues = { name: '', medicated: false, medications: [] };

const CreateFeedRation = ({ router }) => {
  const onSubmit = (data) => {
    return createFeedRation(serializeFeedRation(data))
      .then(() => {
        showToastrMessage('component.toastr.feedRation.created');
        router.push(feedRationsPath);
      })
      .catch((errors) => handleFormErrors(errors, medicationErrorKeys));
  };

  return (
    <section className="small-12 column">
      <Panel>
        <Panel.Heading title={<FormattedMessage id="container.admin.feedRations.createRation" />} />
        <Panel.Body noPadding>
          <div className="row">
            <section className="small-12 medium-10 large-8 column">
              <FormErrorsBox formName={feedRationFormName} excludedFields={rawMedicationErrorKeys} />
              <FeedRationForm onSubmit={onSubmit} initialValues={initialValues} />
            </section>
          </div>
        </Panel.Body>
      </Panel>
    </section>
  );
};

CreateFeedRation.propTypes = {
  router: T.object.isRequired,
};

export default CreateFeedRation;
